module.exports = __webpack_public_path__ + "assets/img/twilight-solar.e7a97cd9.webp";